//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.BoundarySet.js";
let d=[[[0,"BlankDistance",1,0],[0,"CustomBlankDistance",1,0],[0,"CustomFeed",1,0],[0,"CustomStock",1,0],[0,"CustomTolerance",1,0],[0,"FeedUnit",1,0],[0,"FeedValue",1,0],[0,"InTolerance",1,0],[0,"OutTolerance",1,0],[0,"Stock",1,0]],[[[],"CreateBoundaryMemberSetPlanarMill",{R_:{bndSet:"CAM.BoundaryMemberSetPlanarMill"}},0,0],[["distance"],"ExtendOrTrimStartPoint",{},1,0],[["distance"],"ExtendOrTrimEndPoint",{},1,0],[["bndSet","distance"],"MoveStartPoint",{},2,0],[[],"CreateCurveBoundaryFromPermanent",{},0,0]],[]];
SPLM.CAM.BoundarySetPlanarMill = class extends SPLM.CAM.BoundarySet{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.BoundarySetPlanarMill";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.BoundarySetPlanarMill.FeedUnitTypes = Object.freeze({
    "None" : "None", "PerMinute" : "PerMinute", "PerRevolution" : "PerRevolution"});

SPLM.CAM.BoundarySetPlanarMill.TrimExtendPosition = Object.freeze({
    "AtStart" : "AtStart", "AtEnd" : "AtEnd", "AtStartAndEnd" : "AtStartAndEnd", "Unknown" : "Unknown"});

export default SPLM;